import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { mergeSx } from '#/lib/mergeSx';

export const PageContainer: React.FC<BoxProps> = ({ sx, children }) => <Box sx={mergeSx({ pt: 2, flex: '1 1 100%', display: 'flex', maxWidth: '100%' }, sx)}>{children}</Box>;
